export const queryParams = (params) => {
	const query = Object.keys(params)
		.filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
		.map((key) => `${key}=${params[key]}`)
		.join("&");
	return `?${query}`;
};
